import React from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'
import { graphql } from 'react-apollo'
import loadGames from './loadGames.gql'

const ComponentResizer = loadable(() => import('@albatross/common-components/dist/components/ComponentResizer'))
const PromoTileRow = loadable(() => import('@albatross/common-components/dist/components/PromotileRow'))

const PromoTileRowContainer = (props) => {
  const { data, enableContentful, ...rest } = props
  if (data.loading) {
    return null
  }
  if (!data.loading && data.error) {
    return data.error
  }
  const promoTiles = enableContentful ? props.promoTiles : data.promoTiles

  return (
    <ComponentResizer>
      <PromoTileRow
        promoTiles={promoTiles ?? []}
        {...rest}
      />
    </ComponentResizer>
  )
}

PromoTileRowContainer.propTypes = {
  data: PropTypes.object.isRequired,
  clickTag: PropTypes.string,
  campaignHomepage: PropTypes.string,
  background: PropTypes.string,
  venture: PropTypes.string,
  enableContentful: PropTypes.bool,
  promoTiles: PropTypes.array
}

function getVariables (props) {
  const variables = {
    published: true,
    enableContentful: props?.enableContentful ?? false
  };

  ['promoId', 'categoryId', 'sort', 'limit'].forEach((property) => {
    if (props.query && props.query[property]) {
      variables[property] = props.query[property]
    }
  })
  return variables
}

export default graphql(loadGames, {
  options: (props) => {
    return { variables: getVariables(props) }
  }
})(PromoTileRowContainer)
